/**
 * `useShopifyFetcher` / `useBaseFetcher` store two different things in
 * `meta.error`:
 *
 *  - an HTTP failure puts the parsed response body there, e.g.
 *    `{ statusCode: 422, error: 'Unprocessable Entity', message: '...' }`
 *  - a thrown JS/network error puts the `Error` instance there
 *
 * NestJS also sends `message` as a string array for validation failures.
 * This normalises all of those into a single string suitable for showing to
 * the merchant, or `undefined` when there is nothing human-readable — in
 * which case callers should fall back to their own generic copy.
 */
function getFetcherErrorMessage(error: unknown): string | undefined {
  if (!error) return undefined

  if (typeof error === 'string') return error.trim() || undefined

  const message = (error as { message?: unknown }).message

  if (Array.isArray(message)) {
    const joined = message.filter((m) => typeof m === 'string').join(' ')
    return joined.trim() || undefined
  }

  if (typeof message === 'string') return message.trim() || undefined

  return undefined
}

export default getFetcherErrorMessage
